module.exports = __webpack_public_path__ + "static/media/as2cr54.946c3e71.png";